import React, { useState, useEffect } from 'react';
import { Tabs, Spin, Alert, Typography } from 'antd';
import { ToolOutlined } from '@ant-design/icons';
import { useModuleApi } from '../ortak/moduleApi';
import { useAuth } from '../../context/AuthContext';
import { InsaatTakipTab } from './tabs';
import EnerjiSurecPage from './EnerjiSurecPage';
import TeminatMektubuTab from './TeminatMektubuTab';
import SuzmeEnerjiTab from './SuzmeEnerjiTab';
import SurecTakipPage from './SurecTakipPage.jsx';
import '../ortak/nfmodules.css';

const { Title } = Typography;

export default function InsaatEnerjiPage() {
  const api = useModuleApi('/construction');
  const { user } = useAuth();
  const [lookups, setLookups] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    api.get('/lookups')
      .then((lk) => { if (active) setLookups(lk); })
      .catch((e) => { if (active) setError(e?.response?.data?.detail || 'Veriler yüklenemedi'); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);

  if (loading) return <div style={{ display: 'flex', justifyContent: 'center', padding: 80 }}><Spin size="large" /></div>;
  if (error) return <div style={{ padding: 24 }}><Alert type="error" showIcon message="Hata" description={error} /></div>;

  // Kurulum Onay kaldırıldı (talepler doğrudan onaylı); Proje Masrafları Finans'a taşındı.
  // Eski 'Enerji Takip' + 'Enerji Süreç' sekmeleri tek bir Enerji Süreçleri ekranıyla
  // değiştirildi: o ikisi akış motorunu bypass edip ham tarih alanlarına yazıyordu.
  // 'Genel Takip', inşaat ve enerjiyi tek listede gösteren süreç takibi ekranıdır;
  // /surec_takip rotası da çalışmaya devam eder (dış linkler kırılmasın).
  const items = [
    { key: 'genel-takip', label: 'Genel Takip', children: <SurecTakipPage gomulu /> },
    { key: 'insaat-takip', label: 'İnşaat Takip', children: <InsaatTakipTab api={api} lookups={lookups} /> },
    { key: 'enerji-surec', label: 'Enerji Süreçleri', children: <EnerjiSurecPage gomulu /> },
    { key: 'teminat', label: 'Teminat Mektupları', children: <TeminatMektubuTab gomulu /> },
    { key: 'suzme-enerji', label: 'Süzme Enerji', children: <SuzmeEnerjiTab gomulu /> },
  ];

  return (
    <div className="nf-module">
      <Title level={3} style={{ marginTop: 0 }}>
        <ToolOutlined style={{ marginRight: 8 }} /> İnşaat & Enerji
      </Title>
      <Tabs items={items} type="card" destroyInactiveTabPane />
    </div>
  );
}
